import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

const selectSelf = (state: RootState) => state;
const getUnusedRoleState = createSelector(selectSelf, (state) => state.unusedRoleRead);

const getRoles = createSelector(
  getUnusedRoleState,
  (state) => state.roles,
);

export const unusedRoleReadQuery = {
  getRoles,
};
